import { PropsWithChildren, useEffect } from 'react'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from 'i18n/en.json'
import it from 'i18n/it.json'
import es from 'i18n/es.json'
import de from 'i18n/de.json'
import zh from 'i18n/zh.json'
import fr from 'i18n/fr.json'
import { DEFAULT_LANGUAGE } from 'utils/settings'
import { USE_TRANSLATIONS } from 'config'
import { store } from 'store/index'
import { settingsActions } from 'store/settings'
import { loadDynamicTranslations } from 'services/translations'
import { getLanguage } from 'services/translations/lib/hook/useGetLanguage'

export const I18nProvider = ({ children }: PropsWithChildren) => {
  const { dispatch } = store
  useEffect(() => {
    if (USE_TRANSLATIONS) {
      loadDynamicTranslations()
        .then(() => console.debug('Dynamic translations loaded successfully'))
        .catch(() => console.error('Error loading dynamic translations'))
    }
    const lng = getLanguage()
    // Keep <html lang> in sync so screen readers pronounce content correctly
    document.documentElement.lang = lng
    i18n.on('languageChanged', (next) => {
      document.documentElement.lang = next
    })
    i18n
      .use(initReactI18next)
      .init({
        resources: {
          en: {
            translation: en,
          },
          it: {
            translation: it,
          },
          es: {
            translation: es,
          },
          de: {
            translation: de,
          },
          zh: {
            translation: zh,
          },
          fr: {
            translation: fr,
          },
        },
        lng,
        fallbackLng: DEFAULT_LANGUAGE,
        interpolation: {
          escapeValue: false,
        },
      })
      .then(() => {
        i18n.changeLanguage(lng)
        dispatch(settingsActions.setLang(lng))
      })
      .catch(() => console.debug('Translations init error'))
  }, [])

  return <>{children}</>
}
